var _circle, _path, _path2, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongRenyuan5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.75,
    cy: 11.25,
    r: 2.25,
    stroke: "#3F465C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.996 12.79a.5.5 0 10-.707.706l.707-.707zm.07 1.484a.5.5 0 10.708-.707l-.707.707zm-.777-.778l.778.778.707-.707-.778-.778-.707.707z",
    fill: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9.5a.5.5 0 00-.5-.5h-2A3.5 3.5 0 002 12.5v.5a1.5 1.5 0 001.5 1.5h4a.5.5 0 000-1h-4A.5.5 0 013 13v-.5A2.5 2.5 0 015.5 10h2a.5.5 0 00.5-.5z",
    fill: "#3F465C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 5,
    r: 2.5,
    stroke: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_renyuan5.1f695b39.svg";
export { SvgTongyongRenyuan5 as ReactComponent };